module.exports = __webpack_public_path__ + "static/media/Sandwich.7f28b804.svg";